// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Config del proyecto baked at build time. NO EDITAR.

export const APP_CONFIG = {
    name: "Unnamed",
    title: "WEB_New_mRed",
    version: "08.05.2026.01",
    tablePrefix: "gen",
    entryPoint: "EntradaApp",
    loginCollection: "LoginColl",
    autoLogon: false,
    apiBase: "/api/v1",
    defaultLanguage: "javascript",
} as const;
